import Button from '@common/components/controls/Button';
import PopUp from '@common/components/PopUp';
import Translated from '@common/components/Translated';
import '@common/styles/components/feedbackPopUp.pcss';

interface Props {
  hide: () => void;
}

function SupportPopUp({ hide }: Readonly<Props>) {
  return (
    <PopUp
      title={<Translated id="support.popup.title" />}
      close={hide}
      type="narrow"
      noCancelButton
      actionButton={(
        <Button
          type="button"
          onClick={hide}
          data-testid="supportCloseButton"
        >
          <Translated id="common.actions.close" />
        </Button>
      )}
    >
      <div className="support-popup">
        <p className="support-popup__description">
          <Translated id="support.popup.content.brandName" />
        </p>
      </div>
    </PopUp>
  );
}

export default SupportPopUp;
